import { faqs } from "../../constants/faqs";
import Ussd from "../../pages/ussd";
import BenefitsSection from "./BenefitsSection";
import ClientPortalSection from "./ClientPortalSection";
import DownloadSection from "./DownloadSection";
import FaqsSection from "./Faqs";
import Footer from "./Footer";
import HeroSection from "./HeroSection";
import Navigation from "./NavigationHeader";
import ProductsSection from "./ProductsSection";

function App() {
  return (
    <div className="bg-white dark:bg-defaultBlack">
      <Navigation />
      <HeroSection />
      <BenefitsSection />
      <ProductsSection />
      <ClientPortalSection />
      <Ussd />
      <FaqsSection faqs={faqs} />
      <DownloadSection />
      <Footer />
    </div>
  );
}

export default App;
